import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Parses a date-only string ("YYYY-MM-DD" or "YYYY-MM-DDTHH:mm:ss.sssZ")
 * as a LOCAL date, avoiding UTC→local timezone shift that causes off-by-one-day bugs.
 */
export function parseLocalDate(dateStr: string): Date {
  const datePart = dateStr.split('T')[0]; // "YYYY-MM-DD"
  const [y, m, d] = datePart.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/**
 * Formats a date-only string safely in es-MX locale without timezone shift.
 * Accepts both "YYYY-MM-DD" and ISO datetime strings.
 */
export function formatLocalDate(
  dateStr: string,
  options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' }
): string {
  return parseLocalDate(dateStr).toLocaleDateString('es-MX', options);
}

/**
 * "YYYY-MM-DD" for "today" in Mexico City, regardless of the browser's own
 * timezone — used to cap payment/transaction date pickers so a user in a
 * different timezone can't pick a day that's still "tomorrow" in Mexico.
 */
export function getMexicoTodayDateOnly(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Mexico_City' });
}